export enum AnalyticsConstants {
  ANALYTICS_EVENT = "ANALYTICS_EVENT",
}
